/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb


// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)

import React from "react";
import { createRoot } from "react-dom/client";
import App from "../components/App";
import '../stylesheets/application.css';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { AppProvider } from "../contexts/AppContext";
import { ChatProvider } from "../contexts/ChatContext";
import { LiveQuoteProvider } from "../contexts/LiveQuoteContext";

const ROOT_ID = "react-root";
const rootsByContainer = new WeakMap();

const mountReactApp = () => {
  let container = document.getElementById(ROOT_ID);
  if (!container) {
    container = document.createElement("div");
    container.id = ROOT_ID;
    document.body.appendChild(container);
  }

  let root = rootsByContainer.get(container);
  if (!root) {
    root = createRoot(container);
    rootsByContainer.set(container, root);
  }

  // React.StrictMode was causing double renders (which led to double http request)
  root.render(
    <GoogleOAuthProvider clientId="282013015462-kdaq5nkav9ra7ets7hf55anegdrb4ugb.apps.googleusercontent.com">
      {/* <React.StrictMode> */}
      <AppProvider>
        <LiveQuoteProvider>
          <ChatProvider>
            <App />
          </ChatProvider>
        </LiveQuoteProvider>
      </AppProvider>
      {/* </React.StrictMode> */}
    </GoogleOAuthProvider>
  );
};

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", mountReactApp, { once: true });
} else {
  mountReactApp();
}

// Fallback for environments where Turbolinks is still present.
document.addEventListener("turbolinks:load", mountReactApp);
